import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FormSubmit, GetData } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import DataTable from "../../../Common/Components/DataTable";
import { CostRender, removeSepMoney, renderPrice, sepJustMoney } from "../../../Common/Function";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import CommonFrom from "../../../Common/Components/Form";
import { Spinner } from "react-bootstrap";
import BoxShadow from "../../../Common/Components/BoxShadow";
import { ImCoinDollar } from "react-icons/im";
import Create from "../RequestWallet/Create";

function Index() {
  const initialState = {
    loading: false,
    data: {
      data: null,
    },
  };
  const [state, setstate] = useState(initialState);
  const [withdrawState, setWithdrawState] = useState(initialState);

  const Handler = (limit, index) => {
    console.log(limit, index);
    setstate({ ...state, loading: true });
    GetData(index, limit).then(result => {
      setstate({
        loading: false,
        ...state,
        data: result.data,
      });
    });
  };

  const formsubmit = data => {
    setstate({ ...state, loadingBtn: true });
    FormSubmit(data).then(() => {
      setstate({
        ...state,
        loadingBtn: false,
      });
    });
  };
  useEffect(() => {
    Handler();
  }, []);

  const STYLE = {
    div: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      overflow: "hidden",
      borderRadius: "8px",
      background: "#eae9e9",
      padding: "6px 10px",
    },
    input: {
      background: "none",
      borderWidth: 0,
      borderColor: "none",
      boxShadow: "none",
      outline: "none",
      width: "100%",
      fontSize: "16px",
    },
    icon: {
      width: "30px",
      height: "30px",
      fontSize: "16px",
      background: "#E42A3F ",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "30px",
      color: "#f5f5f5",
    },
    btn: {
      background: "none",
      borderWidth: 0,
      boxShadow: "none",
    },
  };

  const costRender = new Intl.NumberFormat("en-US");
  const BTNS = () => {
    return ["50000", "100000", "300000", "500000"].map((btn, key) => (
      <div className="col-3" key={key}>
        <button
          className={`btn ${btn == state.price ? "btn-primary " : "btn-outline-primary "
            }  btn-block text-dark`}
          onClick={() => setstate({ ...state, price: btn })}
          style={{ color: btn == state.price ? "#fff" : "#000" }}
        >
          {costRender.format(btn)}
        </button>
      </div>
    ));
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | کیف پول </title>
      </Helmet>
      {/* <div className="card">
        <div className="card-body"> */}
      {state.loading ? (
        <Loading count={1} col={12} height={300} />
      ) : (
        <Fragment>
          <div className="col-12">
            <div
              className="row justify-content-center"
              style={{ marginBottom: "20px" }}
            >
              <div className="col-md-6">
                <BoxShadow
                  style={{
                    padding: "0",
                  }}
                >
                  <div className=" text-center">
                    <div
                      className="card-header text-white"
                      style={{ backgroundColor: "#e42a3f" }}
                    >
                      <h5>کیف پول</h5>
                    </div>
                    <div className="card-body">
                      <h5 className="card-title mb-3">
                        موجودی فعلی :{" "}
                        {CostRender.format(
                          parseInt(
                            state.data.wallet && state.data.wallet.amount
                          )
                        )}{" "}
                        تومان
                      </h5>
                      <div className="row mt-3">{BTNS()}</div>
                    </div>
                    <div className="col-12 justify-content-center">
                      <div className="col-12" style={STYLE.div}>
                        <input
                          style={STYLE.input}
                          type="search"
                          placeholder="50,000"
                          aria-label="Search"
                          onChange={e =>
                            setstate({ ...state, price: removeSepMoney(e.target.value) })
                          }
                          value={sepJustMoney(state.price)}
                        />
                        <button style={STYLE.btn}>
                          <ImCoinDollar size={22} />
                        </button>
                      </div>
                    </div>
                    <div className="d-flex flex-column border-0 pt-0 mt-4 mb-3">
                      <button
                        disabled={state.loadingBtn || !state.price}
                        href="#"
                        className="btn btn-primary text-white mb-3 ml-auto w-75 justify-content-center "
                        style={{ color: "#000" }}
                        onClick={() => formsubmit({ price: state.price })}
                      >
                        {state.loadingBtn ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          `افزایش اعتبار`
                        )}
                      </button>

                      <button
                        className="btn btn-primary text-white ml-auto w-75 justify-content-center"
                        style={{ color: "#000" }}
                        onClick={() => setWithdrawState({ ...withdrawState, showModal: true })}
                      >
                        برداشت از کیف پول
                      </button>

                    </div>
                  </div>
                </BoxShadow>
              </div>

            </div>
          </div>

          <DataTable
            needSearch={true}
            function={Handler}
            textEmpty="تراکنشی ثبت نشده"
            list={
              state.data && state.data.wallettrx && state.data.wallettrx.data
            }
            data={state.data && state.data.wallettrx}
            currentPage={
              state.data &&
              state.data.wallettrx &&
              state.data.wallettrx.current_page
            }
            header={"لیست تراکنشات کیف پول"}
            heads={[
              {
                title: "مبلغ",
                key: "price",
                type: "unit",
              },
              {
                title: "مانده",
                key: "new_amount",
                type: "unit",
              },
              {
                title: "نوع تراکنش",
                key: "type_fa",
              },
              {
                title: "وضعیت",
                key: "status_fa",
              },
              {
                title: "شماره پیگیری",
                key: "trackCode",
              },

              {
                title: "تاریخ تراکنش",
                key: "created_at",
                type: "date",
                timetype: "date-time",
              },
            ]}
          />
          {/* </div>
          </div> */}

          {/* <div className="row">
            <div className="col-md-6 col-12">
              <div className="card">
                <div className="card-body">
                  <h4>لیست پرداخت ها</h4>
                  <DataTable
                    needSearch={true}
                    heads={[
                      {
                        title: "وضعیت",
                        key: "status",
                        type: "enum",
                        enum: {
                          payed: "پرداخت شده",
                        },
                      },
                      {
                        title: "شماره پیگیری",
                        key: "trackingcode",
                      },

                      {
                        title: "تاریخ تراکنش",
                        key: "created_at",
                        type: "date",
                        timetype: "date",
                      },
                    ]}
                    function={Handler}
                    textEmpty="تراکنشی ثبت نشده"
                    list={
                      state.data &&
                      state.data.payment &&
                      state.data.payment.data
                    }
                    data={state.data && state.data.payment}
                    currentPage={
                      state.data &&
                      state.data.payment &&
                      state.data.payment.current_page
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="card">
                <div className="card-body">
                  <DataTable
                    heads={[
                      {
                        title: "وضعیت",
                        key: "status",
                        type: "enum",
                        enum: {
                          peyed: "پرداخت شده",
                        },
                      },
                      {
                        title: "مبلغ",
                        key: "total_price",
                      },
                      {
                        title: "شماره پیگیری",
                        key: "trackingcodeorder",
                      },

                      {
                        title: "تاریخ تراکنش",
                        key: "created_at",
                        type: "date",
                        timetype: "date",
                      },
                    ]}
                    function={Handler}
                    needSearch={true}
                    textEmpty="تراکنشی ثبت نشده"
                    list={
                      state.data && state.data.sharge && state.data.sharge.data
                    }
                    data={state.data && state.data.sharge}
                    currentPage={
                      state.data &&
                      state.data.sharge &&
                      state.data.sharge.current_page
                    }
                    header="لیست واریز ها"
                    links={[
                      {
                        function: selected => {
                          setstate({ ...state, modal: selected[0] });
                        },
                        undisabled: true,
                        color: "info",
                        size: "col-md-8",
                        html: "مشاهده جزییات",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div> */}
          <CustomModal
            show={state.modal}
            handleClose={() => {
              setstate({ ...state, modal: false });
            }}
            header={"ویرایش دسته بندی"}
          >
            <CommonFrom
              loading={state.loading}
              form={input}
              value={
                state.modal
                  ? state.data.sharge.data[state.modal - 1].payment[0]
                  : ""
              }
            />
          </CustomModal>

          <CustomModal
            show={withdrawState.showModal}
            handleClose={() => { setWithdrawState({ ...withdrawState, showModal: false }); }}
            header={"برداشت از کیف پول"}
          >
            <Create role={true} closeModal={() => { setWithdrawState({ ...withdrawState, showModal: false }); }} />
          </CustomModal>



        </Fragment>
      )}

      {/* </div>
      </div> */}
    </Fragment>
  );
}

export default Index;
const input = [
  {
    label: "مبلغ",
    disabled: true,
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "total_price",
    value: "",
  },
  {
    label: "شماره ارجاع",
    size: "col-md-6",
    disabled: true,
    classNames: "mt-2",
    placeholder: "",
    name: "ref_id",
    value: "",
  },
  {
    label: "شماره تراکنش",
    size: "col-md-6",
    disabled: true,
    classNames: "mt-2",
    placeholder: "",
    name: "transid",
    value: "",
    type: "text",
  },
  {
    label: "شماره پیگیری",
    size: "col-md-6",
    disabled: true,
    classNames: "mt-2",
    placeholder: "",
    name: "trackingcode",
  },
];
